var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.snackbarMessage)?_c('SuawSnackbar',{attrs:{"text-message":_vm.snackbarMessage,"type":_vm.snackbarType,"has-timer":true,"timer-amount":8,"has-dismiss":false},on:{"cancel-click":_vm.onSnackbarCancel,"action-click":_vm.onSnackbarConfirm}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }